var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "changelog-container" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showChangeLogDetails,
              expression: "!showChangeLogDetails"
            },
            {
              name: "change-log-infinite-scroll",
              rawName: "v-change-log-infinite-scroll",
              value: _vm.loadMoreChangelogs,
              expression: "loadMoreChangelogs"
            }
          ],
          staticClass: "changelogs changelogs--md",
          class: {
            "empty-changelog": !_vm.datesShown.length
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "changelog-fixed-title",
              class: { invisible: !_vm.datesShown.length }
            },
            [
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "Today",
                    expression: "'Today'"
                  }
                ]
              })
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.datesShown, function(date, index) {
            return _c(
              "div",
              { key: date, staticClass: "changelog-list-items" },
              [
                _c("div", {
                  staticClass: "changelog-date-title",
                  style: `z-index: ${index + 1}`,
                  domProps: { textContent: _vm._s(date) }
                }),
                _vm._v(" "),
                _vm._l(_vm.groupedChangelogs[date], function(
                  changelog,
                  logIndex
                ) {
                  return _c(
                    "div",
                    {
                      key: `${logIndex}-${changelog.transactionId}`,
                      staticClass: "changelog-entry-list-item",
                      on: {
                        click: function($event) {
                          return _vm.toggleDetails(changelog)
                        }
                      }
                    },
                    [_c("ChangeLogEntry", { attrs: { changelog: changelog } })],
                    1
                  )
                })
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center m-t-10" },
            [
              _vm.loadingLogs
                ? _c("Loader", { attrs: { "custom-class": "size-sm" } })
                : _vm._e(),
              _vm._v(" "),
              _vm.loadingLogs
                ? _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("MESSAGE_LOADING_ACTIVITY")) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.loadingLogs &&
              (!_vm.shouldCheckForMoreLogs || !_vm.datesShown.length)
                ? _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("MESSAGE_NO_ACTIVITY")) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      !!_vm.changelogDetails
        ? _c("ChangeLogDetails", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showChangeLogDetails,
                expression: "showChangeLogDetails"
              }
            ],
            attrs: {
              "show-change-log-details": _vm.showChangeLogDetails,
              changelog: _vm.changelogDetails,
              "changelog-related-actions":
                _vm.groupedTransactionIds[_vm.changelogDetails.transactionId],
              wide: _vm.wide
            },
            on: { "toggle-details": _vm.toggleDetails }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }